import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let CourseGallery = () => {
    const verticalImageList = [
        "img002.jpg",
        "img010.jpg",
        "img011.jpg",
        "img012.jpg",
        "img013.jpg",
        "img017.jpg",
        "img018.jpg",
        "img021.jpg",
        "img022.jpg"
    ]

    const horizontalImageList = [
        "img001.jpg",
        "img003.jpg",
        "img004.jpg",
        "img005.jpg",
        "img006.jpg",
        "img007.jpg",
        "img008.jpg",
        "img009.jpg",
        "img014.jpg",
        "img015.jpg",
        "img016.jpg",
        "img019.jpg",
        "img020.jpg",
        "img023.jpg",
        "img024.jpg"

    ]

    return(
        <div className="content text-center">
            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-kurs/" + path)} rounded />)}
            </div>
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-kurs/" + path)} rounded />)}
            </div>
            
        </div>
    )
}

export default CourseGallery;